import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SBAMultiSelectCheck, SBADropDown, SBAAutoComplete, SBAComboBox } from "../../../UiComponents/SBADropDown";
import { SBGrid } from "../../../UiComponents/SBAAGgrid";
import { sbaAxios } from "../../../utils/sbaAxios";
import { getCustomSettings, getTasks, DownloadDocument, insertorupdateTask, DeleteDocument, insertOrUpdateActivityDocument, updateTaskComplete } from "../../../../config/apiConfig";
import moment from "moment";
import { SBADrawer } from "../../../UiComponents/SBADrawer";
import { AgGridReact } from "ag-grid-react";
import { SBAEditor } from '../../../UiComponents/SBAEditor';
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";
import { getActivityEntities } from "../../../actions/investmentAction";
import { TasksEntityType } from "../../../../config/investorConfig";
import { SBNotify } from "../../../utils/sbNotify";
import { Modal } from "react-bootstrap";
import { AttachmentModal } from "../../tasks/taskBoard";
import { Link } from "react-router-dom";
import {  useParams } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import {
    getTaskTypesAction, 
    getTaskAssigneeAction,
    getTaskDocumentsAction,
    getActivityTaskViewSelectAction,
} from "../../../actions/tasksAction";
export const Tasks = () => {

    const removeDrawerTabIndex = () => {
        const drawers = document.getElementsByClassName('rs-drawer-wrapper');
        Array.from(drawers).forEach(drawer => {
          drawer.removeAttribute('tabIndex');
        });
    };
    removeDrawerTabIndex();
    const tasktypeData = [
        {
            "TypeId": -1,
            "TypeName": "All"
        },
        {
            "TypeId": 1,
            "TypeName": "Open"
        },
        {
            "TypeId": 2,
            "TypeName": "Completed"
        },

    ]
    const [taskType,setTaskType] = useState(tasktypeData);
    const [taskTypeIds,setTaskTypeIds]=useState(taskType);
    const [typeselected, setTypeselected] = React.useState({ value: taskType, allSelected: true });
    const [colDef, setColDef] = useState([]);
    const [appliedFilter, setAppliedFilter] = useState({});
    const [tasks, setTasks] = useState([]);
    const taskGridRef = useRef();
    const Gstate =
        useSelector((state) => {
            return state;
        }) || {};
    const dispatch = useDispatch();
    const params = useParams();
    const taskAssignees = Gstate?.tasks?.taskAssignee || [];
    const activityEntities = useSelector((state) => state?.ActivityEntity?.Activityentity?.filter(item=>item.EntityId!=-1)) || [];
    const taskTypes = Gstate?.tasks?.taskType || [];
    const taskDocuments = Gstate?.tasks?.taskDocuments || [];
    const [Mode, setMode] = useState();
    const [showDrawer, setshowDrawer] = useState(false);
    const [selectedType, setSelectedType] = useState();
    const [selectedOwner, setSelectedOwner] = useState();
    const [selectedName, setSelectedName] = useState();
    const [selectedBody, setSelectedBody] = useState();
    const [selectedEntityType, setSelectedEntityType] = useState();
    const [selectedEntity, setSelectedEntity] = useState();
    const [selectedDueDate, setSelectedDueDate] = useState();
    const [selectedstartDate, setSelectedstartDate] = useState();
    const [selectedCompletedDate, setSelectedCompletedDate] = useState(false);
    const [newselectedFiles, setSelectedNewFiles] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [deleteAttachModal, setDeleteAttachModal] = useState(false);
    const [selectedDocumentId, setSelectedDocumentId] = useState();
    const [selectedTaskDocuments, setSelectedTaskDocuments] = useState([]);
    const [selectedActivityId, setselectedActivityId] = useState();
    const [selectedActivityTaskId, setselectedActivityTaskId] = useState();
    const [hideCompleted, sethideCompleted] = useState(false);
    const [showAttachment, setShowAttachment] = useState(false);
    const [render, setRender] = useState(true);
    const [task, setTask] = useState([]);
    const comboRef = useRef(null);
    useEffect(() => {
        document.title = `Investor Details`;
        dispatch(getTaskTypesAction());
        dispatch(getTaskAssigneeAction());
        dispatch(getActivityTaskViewSelectAction());
        fetchGridData();
        dispatch(getActivityEntities(TasksEntityType.Contact, null, 2));
        setSelectedFiles([]);
        setSelectedNewFiles([]);
    }, []);

    useEffect(() => {
        getTaskslist(taskTypeIds, params.ContactId);
    }, [render]);

    useEffect(() => {
        console.log('combo ref: ', comboRef.current)
        const observer = new MutationObserver(() => {
            const popup = document.querySelector(".modalDD.k-animation-container");
            if (popup && comboRef.current?.element) {
              const comboBoxWidth = comboRef.current.element.getBoundingClientRect().width;
              popup.style.width = `${comboBoxWidth}px`;
              console.log('element: ', popup, "width: ", comboBoxWidth)
            }
          });
        
          // Start observing DOM mutations
          observer.observe(document.body, { childList: true, subtree: true });
        
          return () => observer.disconnect(); // Cleanup when unmounting
      }, []);

    useEffect(() => {
        
        setSelectedTaskDocuments(taskDocuments);
       
        if (Mode === "Edit") {
           
            setSelectedFiles(taskDocuments);
        }

    }, [Gstate]);

    // Attachment Grid
    const defaultdocColDef = {
        sortable: true,
        flex: 1,
        resizable:true
    };

    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            const columns = customSettings?.columns
                .filter(item => item.colId !== "Action" && item.colId !== "FilterType")
                .map(item => ({ ...item }));
            setColDef(columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
          console.error("Error fetching custom settings:", error);
        }
      };
      
    const getTaskslist = async (TaskTypeIds,contactid)=>
      {        
        try {
            const response = await sbaAxios({
                url: `${getTasks}?contactId=${contactid}`,
                method: 'get',
            })
            const Tasks = response;
            let filteredData = [];
            if (TaskTypeIds.length !== 0) {
                TaskTypeIds.forEach((type) => {
                    if (type.TypeName === "Open") {
                        const filteredTasks = Tasks.filter(task => !task.IsCompleted).map(task => ({
                            ...task,
                            FilterType: "Open"
                        }));
                        filteredData = [...filteredData, ...filteredTasks];
                    } else if (type.TypeName === "Completed") {
                        const filteredTasks = Tasks.filter(task => task.IsCompleted).map(task => ({
                            ...task,
                            FilterType: "Completed"
                        }));
                        filteredData = [...filteredData, ...filteredTasks];
                    }
                });
            }

            setTasks(filteredData);
            setTask(filteredData)
        } catch (error) {
                 }

      }
    // Close Drawer...
    const closeModal = () => {
        setshowDrawer(false);
    };
  const getCustomSetting = async () => {
    try {
      
        const response = await sbaAxios({ url: `${getCustomSettings}${1024}` });
        if (response) {
          const apiColDef = JSON.parse(response.CustomSettingsValue);
          const apiFilters = JSON.parse(response.CustomFilterValue);
          const formattedDef = apiColDef.map((item) => {
            
            return {
              ...item,
                field: item.colId,
                cellRenderer:
                    item.colId === "AttachmentCount"? HyperlinkRenderer:null,
                valueFormatter: item.colId === "DueDateTime"
                    ? (data) => data.value ? moment(data.value).format('MM/DD/YYYY') : ""
                    : item.colId === "TaskBody"
                    ? (data) => data.value ? removeHtmlTagsFormatter(data.value): "": null,
              "headerName": item.colId === "TaskName" ? "Subject":item.colId === "TaskBody" ? "Details" : item.colId === "TaskType" ? "Subject Type" : item.colId === "SubjectType" ? "Task Type" :item.colId === "AssignedToUserName" ? "Owner" :item.colId === "DueDateTime" ? "Due Date" : null,
            }
          });
          formattedDef.push({ field: "FilterType", headerName: "Task Type",  filter: true });
          formattedDef.push({ field: "Action", headerName: "Action", cellRenderer: EditButtonRenderer, filter: false });

          return { columns: formattedDef, filters: apiFilters };
        }
      }
         catch (error) {
      console.log(error);
      throw error;
    }
    };

    const HyperlinkRenderer = (props) => {
        const isEditable = useSelector(state => state.authorizationData.isEditable);
        const [isEdit, setIsEdit] = useState(isEditable);
        useEffect(() => { setIsEdit(isEditable) }, [isEditable])
        const ActivityId = props.data.ActivityId;
        const handleLinkClick = (event) => {
            setShowAttachment(true);
            setTask(props.data);
           
        };

        return <Link onClick={isEdit && handleLinkClick}>{props.data.AttachmentCount !== 0 ? props.data.AttachmentCount : <i className="fa-solid fa-plus" />}</Link>;
    };

    const removeHtmlTagsFormatter = (value) => {

        if (typeof value !== 'string') {
            return value;
        }

        return value.replace(/<[^>]*>?/gm, '');
    };

    // HideCompleted Checkbox change...
    const changehideCompleted = (e) => {
        sethideCompleted(e.target.checked);
        hidecompleteddata(e.target.checked);
    };

    // Hide completed tasks load..
    const hidecompleteddata = (IsHide) => {
        if (IsHide === true) {
            const filteredtasks = tasks.filter((item) => item.IsCompleted !== true);
            setTasks(filteredtasks);
        } else {
            setTasks(tasks);
        }
    }

    const onAddButtonClick = () => {
        setshowDrawer(true);
        setMode("Add");
        dispatch(getActivityEntities(TasksEntityType.Contact, null, 2));
        setSelectedBody();
        setSelectedDueDate();
        setSelectedstartDate();
        setSelectedEntity({});
        setSelectedEntityType(TasksEntityType.Contact);
        setSelectedName();
        setSelectedOwner({
            "AssignedToUserId": -1,
            "AssignedToUserName": "Please Select",
        });
        setSelectedType({
            "TaskTypeId": -1,
            "TaskType": "Please Select",
        });
       
        setSelectedFiles([]);
    };
   
    // Task Grid Edit Button....
    const EditButtonRenderer = (props) => {
        const isEditable = useSelector(state => state.authorizationData.isEditable);
        const [isEdit, setIsEdit] = useState(isEditable);
        useEffect(() => { setIsEdit(isEditable) }, [isEditable]);
        const handleEditClick = () => {
            const isComplete = props.data.IsCompleted;
            dispatch(getTaskDocumentsAction(props.data.ActivityId));
            setSelectedType({ "TaskTypeId": props.data.TaskTypeId, "TaskType": props.data.TaskType });
            setSelectedBody(props.data.TaskBody);
            setSelectedName(props.data.TaskName);
            setSelectedDueDate(props.data.DueDateTime);
            setSelectedstartDate(props.data.StartDateTime);
            setselectedActivityId(props.data.ActivityId);
            setselectedActivityTaskId(props.data.ActivityTaskId);
            setSelectedOwner({ "AssignedToUserId": props.data.AssignedToUserId, "AssignedToUserName": props.data.AssignedToUserName });
            setSelectedEntity({ "EntityId": props.data.EntityId, "EntityName": props.data.EntityName });
            setSelectedEntityType(props.data.EntityTypeId === 1 ? TasksEntityType.Account : TasksEntityType.Contact);
            if (isComplete !== true) {
                
                setshowDrawer(true);
                setMode("Edit");
            }
            setSelectedNewFiles([]);


        }      
        return (
            <>
                <button
                    style={{ border: "none", height: "0px" }}
                    onClick={(e) => { isEdit && handleEditClick() }}
                >
                    <i
                        className="fas fa-edit"
                        style={{ color: (props.data.IsCompleted !== true && isEdit !== false) ? "#47A547" : "#808080", margin: "0 8px", cursor: "pointer" }}
                    ></i>
                </button>
               
                    
               
            </>
        );
    };
    const typeDDChange = (e) => {
        const currentSelectAll = taskTypeIds?.some((i) => i?.TypeName?.trim() === "All") || false;
        const nextSelectAll = e.value.some((i) => i?.TypeName?.trim() === "All");
        let value = e.value;
        const currentCount = typeselected.value.length;
        const nextCount = value?.length;
        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            taskType.length - 1 === nextCount
        ) {
            value = taskType;
        } else if (
            nextCount < currentCount &&
            currentCount === taskType.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.TypeName.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = taskType
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        
        setTaskTypeIds(value);    
        getTaskslist(value, params.ContactId);
    };
    const AttachDeleteButtonRenderer = (props) => {

        const handleDeleteClick = () => {
            if (props.data.DocumentId !== 0) {
                setDeleteAttachModal(true);
                setSelectedDocumentId(props.data.DocumentId)
            }
            else {

                const updatedFiles = newselectedFiles.filter((item, index) => item.rowIndex !== props.data.rowIndex);
                setSelectedNewFiles(updatedFiles);
                const seldoc = selectedFiles.filter((item, index) => item.rowIndex !== props.data.rowIndex);
                setSelectedFiles(seldoc)
                document.getElementById('fileInput').style.display = 'none';
                document.getElementById('fileInput').value = '';
                document.getElementById('fileInput').style.display = 'block';

            }

        }

        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleDeleteClick}
                ></i>
            </div>
        );
    };
    // Edit Attachment start...
    const pdfview = (params) => {
        try {
            const documentId = params.data.DocumentId;
            const documentName = params.data.DocumentName;
            const fileExtension = params.data.DocumentExtension.toLowerCase();
            const urlBuild = DownloadDocument + btoa(documentId.toString());
            sbaAxios({ url: urlBuild }).then((response) => {
                if (fileExtension === "pdf") {
                    window.open(urlBuild)
                } else {
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(response);
                    link.download = documentName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            });
        } catch (error) {
            console.error("Error opening document:", error);
        }
    };

    const AttachmentCellRenderer = (params) => {
        const documentName = params.data.DocumentName;
        return <span onClick={() => pdfview(params)}>{documentName}</span>;
    };
    const columnnewdocDefs = [
        {

            field: "DocumentName",
            headerName: "File Name",
            sort: "asc",
            pinned: "left",
            width: 400,
            filter: "agTextColumnFilter",
            cellRenderer: AttachmentCellRenderer,
            tooltipField: 'FileName'
        },
        {
            field: "DocumentExtension",
            headerName: "Extension",
            pinned: "left",
            maxWidth: 150,
        },
        {
            headerName: "Delete",
            field: "",
            maxWidth: 100,
            cellRenderer: AttachDeleteButtonRenderer
        }
    ];
    // Drawer Start....
    const typedropdownchange = (e) => {
        setSelectedType(e.value);
    };

    const Ownerddchange = (e) => {
        setSelectedOwner(e.value);
    };


    const txtNamechange = (event) => {
        setSelectedName(event.target.value);
    };
    const duedateChange = (newDate) => {
        setSelectedDueDate(newDate);
    };

    const startdateChange = (newDate) => {
        setSelectedstartDate(newDate);
    };

   
    const txtBodyChange = (event) => {
        setSelectedBody(event.html);
    };
    const changeCompleteddate = (e) => {
        setSelectedCompletedDate(e.target.checked);

    };
    const handleRadioChange = (event) => {
        setSelectedEntity([]);
        const entityType = event.target.value === "account" ? TasksEntityType.Account : TasksEntityType.Contact;
        setSelectedEntityType(entityType);
        dispatch(getActivityEntities(entityType, null, 2))
    };
    const entityChange = (e) => {
        console.log("event: ", e.value);
        if(e.value)
        {
            const selectedEntity=e.value;
            setSelectedEntity(selectedEntity);
        }
        else {
            setSelectedEntity({EntityId:0,EntityName:""});
        }

        // if (e.syntheticEvent.type === "change") {
        //     if (e.value) {

        //         dispatch(getActivityEntities(selectedEntityType, e.value, 2))

        //     }
        // }
        // if (e.syntheticEvent.type === "click") {
        //    const selectedDataItem = activityEntities.find(item => item.EntityName === e.target.value);
        //     setSelectedEntity(selectedDataItem);
        // }

    };
    // insert CompletedDate
    const UpdateTasksComplete = () => {

        const savecompletedata = {
            "ActivityTaskId": selectedActivityTaskId,
            "ModifiedByUserId": 0,
        }
        sbaAxios({
            url: `${updateTaskComplete}`,
            method: "post",
            data: savecompletedata,
        }).then((response) => {
            setSelectedCompletedDate(false);
            getTaskslist(taskTypeIds, params.ContactId);
        }).catch((error) => {
            console.error(error);
        });
    };

    // Insert/Update Tasks...
    const InsertorUpdateTasks = () => {
        let ifsave = true;
        const savedata = {
            "activityId": Mode === "Add" ? 0 : selectedActivityId,
            "activityTaskId": Mode === "Add" ? 0 : selectedActivityTaskId,
            "taskName": selectedName,
            "taskBody": selectedBody,
            "taskTypeId": selectedType.TaskTypeId,
            "entityTypeId": selectedEntityType,
            "entityId": selectedEntity.EntityId,
            "assignedToUserId": selectedOwner.AssignedToUserId,
            "startDateTime": selectedstartDate,
            "dueDateTime": selectedDueDate,
            "modifiedByUserId": 0,
            "taskStatus": "T",
        }

        if (selectedType.TaskTypeId === -1) {
            ifsave = false;
            SBNotify({ Msg: "Please Select the Activity Type", type: "error" });
        }
        else if (selectedOwner.AssignedToUserId === -1) {
            ifsave = false;
            SBNotify({ Msg: "Please Select the Owner", type: "error" });
        }
        else if (!selectedName) {
            ifsave = false;
            SBNotify({ Msg: "Please Enter Subject", type: "error" });
        }
        else if (!selectedstartDate) {
            ifsave = false;
            SBNotify({ Msg: "Please Enter the Start Date", type: "error" });
        }
        else if (!selectedDueDate) {
            ifsave = false;
            SBNotify({ Msg: "Please Enter the Due Date", type: "error" });
        }
        if (ifsave) {
            sbaAxios({
                url: `${insertorupdateTask}`,
                method: "post",
                data: savedata,
            }).then((response) => {
               
                if (newselectedFiles.length > 0) {

                    InsertActivityDocuments(response);
                                      
                }

                if (Mode === "Edit") {
                    if (selectedCompletedDate === true) {
                        UpdateTasksComplete();
                    }

                }
                getTaskslist(taskTypeIds, params.ContactId);
                closeModal();
                setshowDrawer(false);
                if (Mode === "Add")
                    SBNotify({ Msg: "Task Saved Successfully", type: "success" });
                else
                    SBNotify({ Msg: "Task Updated Successfully", type: "success" });

               
            }).catch((error) => {
                SBNotify({ Msg: "some error  occured", type: "error" });
            });
        }

    };
    const deleteSelectedAttachment = (DocId) => {
        sbaAxios({
            url: `${DeleteDocument}${selectedActivityId},${DocId}`
        })
            .then((res) => {
                setDeleteAttachModal(false);
                dispatch(getTaskDocumentsAction(selectedActivityId));
                getTaskslist(taskTypeIds, params.ContactId);
            })
            .catch((error) => {
                SBNotify({ Msg: error, type: "error" });
            });
    } 
    // Insert Documents...
    const InsertActivityDocuments = (activityid) => {
        const DocumentData = newselectedFiles.map((obj) => ({
            ActivityId: activityid,
            DocumentId: 0,
            DocumentName: obj.DocumentName,
            DocumentContent: obj.base64String,
            DocumentExtension: obj.DocumentExtension,
            DocumentDate: moment(selectedstartDate),
            RuleId: 0,
            IsPartnerLetter: false,
            IsEmailForwarded: false,
            IsReturnsProcessed: false,
            IsManagerLetter: false,
            ModifiedBy: 0,
            ActivitySourceId: 1
        }));

        sbaAxios({
            url: `${insertOrUpdateActivityDocument}`,
            method: "post",
            data: DocumentData,
        }).then((response) => { 
            getTaskslist(taskTypeIds, params.ContactId);
        })

            .catch((error) => {
                console.error(error);
            });

    };
    const handleFileChange = (event) => {
        const newFiles = event.target.files;

        if (newFiles.length > 0) {
            const updatedFiles = [...newselectedFiles];
            const startingRowIndex = updatedFiles.length;

            for (let i = 0; i < newFiles.length; i++) {
                const file = newFiles[i];
                const fileName = file.name;
                const lastDotIndex = fileName.lastIndexOf('.');
                const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';
                const reader = new FileReader();
                reader.onload = function () {
                    if (reader.result) {
                        const arrayBuffer = reader.result;
                        const base64String = arrayBufferToBase64(arrayBuffer);
                        const rowIndex = startingRowIndex + i;
                        updatedFiles.push({ file, fileName, extension, base64String, rowIndex });
                        setSelectedTaskDocuments([...selectedTaskDocuments, { DocumentId: 0, DocumentName: fileName,DocumentExtension:extension,rowIndex}]);
                        setSelectedNewFiles([...newselectedFiles, { DocumentId: 0, DocumentName: fileName, DocumentExtension: extension, base64String: base64String, rowIndex }]);
                        setSelectedFiles([...selectedFiles, { DocumentId: 0, DocumentName: fileName, DocumentExtension: extension, rowIndex }]);

                    }
                };

                reader.readAsArrayBuffer(file);
            }
        }

    };
    // Attachment Add end...
    const arrayBufferToBase64 = (arrayBuffer) => {
        const binary = [];
        const bytes = new Uint8Array(arrayBuffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary.push(String.fromCharCode(bytes[i]));
        }
        return btoa(binary.join(''));
    };
    return(
        <>

          <div>        
             <div className="bg-white mb-2 p-3 m-3 border rounded">
                 <div >
                     <div className="row">
                         <div className="col-md-3">
                        
                             <label
                                 for="select fund"
                                 className="mb-1 ms-2 fw-semibold fs-12"
                             >
                                 Task Type
                               </label>
                             <div>
                                 <SBAMultiSelectCheck
                                     className="w-75"
                                     data={taskType}
                                     value={taskTypeIds}
                                     dataItemKey="TypeId"
                                     textField="TypeName"
                              
                                     onChange={typeDDChange}
                                     tags={
                                        taskTypeIds?.length > 0
                                             ? [{ text: `${taskTypeIds.length} items selected`, data: [...taskTypeIds] }]
                                             : []
                                     }
                                     
                                 />
                             </div>

                         </div>
                         <div className="d-flex justify-content-end gap-2">
                                <button  className="p-sm-btn mx-1"
                                 onClick={() => onAddButtonClick()}>                                 
                                 <i className="fa-solid fa-plus" /> Add</button>                                
                              </div>
                         
                         </div>
                         </div>
                         </div>
                         <div className="px-3">
              
                      <>
                          <SBGrid
                            ref={taskGridRef}
                            column={colDef}
                            row={tasks}
                            pageSize={15}
                            rowSelection="single"
                            filters={appliedFilter}
                            componentID={1024}

                          ></SBGrid>
                      </>
              

                </div>
                <SBADrawer
                    open={showDrawer}
                    setOpen={setshowDrawer}
                    close={false}
                    title={"Insert/Update Task"}
                >
                    <div>
                        <div>
                            <div className="mb-4">
                                <label className="header-container m-1">
                                    <b>Activity Type:</b>
                                </label>

                                <div>
                                    <SBADropDown
                                        className="w-50"
                                        textField={"TaskType"}
                                        valueField={"TaskTypeId"}
                                        data={taskTypes}
                                        value={selectedType}
                                        popupSettings={{ className: "modalDD" }}
                                        disabled={Mode === "Edit"}
                                        onChange={typedropdownchange}
                                    />
                                </div>
                            </div>
                            <div className="mb-4">
                                <label className="header-container m-1">
                                    <b>Owner:</b>
                                </label>
                                <div>
                                    <SBADropDown
                                        className="w-50"
                                        textField={"AssignedToUserName"}
                                        valueField={"AssignedToUserId"}
                                        data={taskAssignees}
                                        value={selectedOwner}
                                        popupSettings={{ className: "modalDD" }}
                                        onChange={Ownerddchange}
                                    />
                                </div>
                            </div>
                            <div className="mb-4">
                                <label className="header-container m-1">
                                    <b>Subject: </b>
                                </label>
                                <div>
                                    <input
                                        className="form-control w-50"
                                        type="text"
                                        value={selectedName}
                                        onChange={txtNamechange}
                                    />
                                </div>
                            </div>
                            <div className="mb-4">
                                <label className="header-container m-1">
                                    <b>Start Date: </b>
                                </label>
                                <div>
                                    <SBDatePicker
                                        className="w-50"
                                        id="DueDate"
                                        value={selectedstartDate ? moment(selectedstartDate) : null}
                                        onChange={startdateChange}
                                    ></SBDatePicker>
                                </div>
                            </div>

                            <div className="mb-4">
                                <label className="header-container m-1">
                                    <b>Due Date: </b>
                                </label>
                                <div>
                                    <SBDatePicker
                                        className="w-50"
                                        id="DueDate"
                                        value={selectedDueDate ? moment(selectedDueDate) : null}
                                        onChange={duedateChange}
                                    ></SBDatePicker>
                                </div>
                            </div>
                            {Mode === "Edit" ? (
                                
                                <div className="p-2">
                                    <input
                                        className="p-4"
                                        type="checkbox"
                                        id="completedDate"
                                        checked={selectedCompletedDate}
                                        onChange={changeCompleteddate}
                                    />
                                    <label className="label ms-2">Is Completed</label>
                                </div>
                            ) : (
                                ""
                            )}
                            <div className="mb-4">
                                <label className="header-container m-1">
                                    <b>Body:</b>
                                </label>
                                <div>

                                    <SBAEditor id="editor" onChange={txtBodyChange} defaultContent={selectedBody} editorHeight={300} setContent={setSelectedBody} />

                                </div>
                            </div>
                            <div className="mb-4">
                                <div className="d-flex align-items-center gap-5">
                                    <div className="form-check">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            name="table-options"
                                            id="contact"
                                            value="contact"
                                            checked={selectedEntityType === 0}
                                            //disabled={Mode === "Edit"}
                                            onChange={handleRadioChange}
                                        />
                                        <label htmlFor="asset" className="form-check-label">
                                            Contacts
                                        </label>
                                    </div>
                                    <div className="form-check ms-3">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            name="table-options"
                                            id="account"
                                            value="account"
                                            checked={selectedEntityType === 1}
                                            //disabled={Mode === "Edit"}
                                            onChange={handleRadioChange}
                                        />
                                        <label htmlFor="group" className="form-check-label">
                                            Accounts
                                        </label>
                                    </div>

                                    <SBAComboBox
                                        ref={comboRef}
                                        data={activityEntities}
                                        onChange={(e) => { entityChange(e) }}
                                        textField="EntityName"
                                        popupSettings={{ style: {zIndex: 1051}, className: 'modalDD' }}
                                        suggest={false}
                                        valueField={"EntityId"}
                                        clearButton={false}
                                        value={selectedEntity}

                                    />
                                </div>
                            </div>
                            {/*{Mode === "Add" && (*/}
                            <>
                                <div className="row" style={{ marginTop: "10px" }}>
                                    <div style={{ position: "relative" }}>
                                        <input
                                            type="file"
                                            id="fileInput"
                                            className="input-hidden"
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                </div>

                                <div className="row" style={{ marginTop: "10px" }}>
                                    <div
                                        className="ag-theme-alpine"
                                        style={{ width: "100%", height: "300px" }}
                                    >
                                        <AgGridReact
                                            columnDefs={columnnewdocDefs}
                                            rowData={selectedFiles}
                                            defaultColDef={defaultdocColDef}
                                            overlayNoRowsTemplate={`<span>${"No data Available"}</span>`}
                                        ></AgGridReact>
                                    </div>
                                </div>
                            </>
                            {/* )}*/}
                            <div className="mt-4">
                                <button className="s-sm-btn mx-1" onClick={closeModal}>
                                    Cancel
                                </button>
                                <button className="p-sm-btn mx-1" onClick={InsertorUpdateTasks} >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </SBADrawer>

                {/* Attachment Delete Modal ----- */}
                <Modal show={deleteAttachModal}>
                    <Modal.Header
                        closeButton
                        onClick={() => {
                            setDeleteAttachModal(false);
                        }}
                    >
                        <Modal.Title>
                            Do you want to delete the selected Document?
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Document will be deleted permanently. Are you sure?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            className="s-sm-btn mx-1"
                            onClick={() => {
                                setDeleteAttachModal(false);
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            className="p-sm-btn mx-1"
                            onClick={() => {
                                deleteSelectedAttachment(selectedDocumentId);
                            }}
                        >
                            Yes
                        </button>
                    </Modal.Footer>
                </Modal>
                <AttachmentModal showModal={showAttachment} closeModal={() => { setShowAttachment(false); setRender(value => !value) }} task={task} />

                         </div>
        </>
    )
    
  
  };
  